import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "BusinessTransaction";
const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useBusinessTransactionState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useAuthState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export function useBusinessTransactionDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useBusinessTransactionState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export const BusinessTransactionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
